export default "<h3>October 20, 2018</h3>\r\n<p>Update 0.4 adds a new car.</p>\r\n<h3>Additions</h3>\r\n<ul>\r\n    <li>S462T B-Sport R</li>\r\n</ul>";